(function () {
  var bar = document.querySelector('[data-pawable-sticky-atc]');
  if (!bar) return;

  var buyBoxForm = document.querySelector('form[action*="/cart/add"]');
  if (!buyBoxForm) return;

  bar.hidden = false;

  var setVisible = function (visible) {
    if (visible) {
      bar.setAttribute('data-visible', '');
    } else {
      bar.removeAttribute('data-visible');
    }
  };

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(buyBoxForm);
  }

  var scrollButton = bar.querySelector('[data-pawable-sticky-atc-scroll]');
  if (scrollButton) {
    scrollButton.addEventListener('click', function () {
      buyBoxForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
})();
